import React from 'react';
import bghideandseek from 'assets/img/comingSoon/hideandseek/bg-hideandseek.jpg';
import hideandseeklabel from 'assets/img/comingSoon/hideandseek/hideandseeklabel.png';
import hideandseekcomingsoon from 'assets/img/comingSoon/hideandseek/hideandseek-coming-soon.png';

import bgsipa from 'assets/img/comingSoon/sipa/bg-sipa.jpg';
import sipalabel from 'assets/img/comingSoon/sipa/sipalabel.png';

import bgpitikbulag from 'assets/img/comingSoon/pitikbulag/bg-pitikbulag.jpg';
import pitikbulaglabel from 'assets/img/comingSoon/pitikbulag/pitikbulag-label.png';
import pitikbulagcomingsoon from 'assets/img/comingSoon/pitikbulag/pitikbulag-coming-soon.png';

import hideandseekBack from 'assets/img/comingSoon/hideandseekBack.png';
import backpitikbulag from 'assets/img/comingSoon/back-pitikbulag.png';
import backsipa from 'assets/img/comingSoon/back-sipa.png';
import footer from 'assets/img/comingSoon/footer.png';

const parse_query_string = (query) => {
  const vars = query.split('&');
  const query_string = {};
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const key = decodeURIComponent(pair[0]);
    const value = decodeURIComponent(pair[1]);
    if (typeof query_string[key] === 'undefined') {
      query_string[key] = decodeURIComponent(value);
    } else if (typeof query_string[key] === 'string') {
      const arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
};

function ComingSoon() {
  const query = window.location.search.substring(1);
  const qs = parse_query_string(query);
  const handleBack = (e) => {
    e.preventDefault();
    window.location.href = '/';
  };

  const renderBgImage = () => {
    if (qs.code === 'gb-hideandseek') return bghideandseek;
    if (qs.code === 'gb-pitikbulag') return bgpitikbulag;
    return bgsipa;
  };

  const renderBackImage = () => {
    if (qs.code === 'gb-hideandseek') return hideandseekBack;
    if (qs.code === 'gb-pitikbulag') return backpitikbulag;
    return backsipa;
  };

  const renderLabel = () => {
    if (qs.code === 'gb-hideandseek') return hideandseeklabel;
    if (qs.code === 'gb-sipa')
      return "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";
    return pitikbulaglabel;
  };

  const renderComingSoon = () => {
    if (qs.code === 'gb-hideandseek') return hideandseekcomingsoon;
    if (qs.code === 'gb-sipa') return sipalabel;
    return pitikbulagcomingsoon;
  };

  return (
    <>
      <div className="relative h-full">
        <img
          src={renderBgImage()}
          alt=""
          className="object-cover object-center h-full w-full"
        />
        <div className="flex justify-center">
          <img
            src={renderLabel()}
            alt=""
            className="absolute top-0 h-48 w-auto mt-24 lg:h-auto lg:w-96 md:h-auto md:w-96 object-fill"
          />
        </div>
        <div className="flex justify-center">
          <img
            src={renderComingSoon()}
            alt=""
            className="absolute bottom-0 w-60 mb-32"
          />
        </div>
        <button
          onClick={handleBack}
          type="button"
          className="absolute top-0 left-0 z-50"
        >
          <img src={renderBackImage()} alt="" className="h-20 w-20 mt-4 ml-4" />
        </button>
        <div
          className="absolute bottom-0 w-full h-full  bg-contain bg-bottom bg-no-repeat"
          style={{ backgroundImage: `url(${footer})` }}
        />
      </div>
    </>
  );
}

ComingSoon.propTypes = {};

export default ComingSoon;
